export interface ISocialBaseInfo {
  unionId: string;
  name: string; // 姓名
  age: string;
  gender?: string; // 性别
  genderName?: string;
  birthday: string; // 出生年月
  photoIdL: string;
  photoUrl?: string; // 头像
  interCode: string; // 区号
  interCodeName: string;
  phone: string; // 电话
  email: string; // 邮箱
  cityId: string;
  cityName: string; // 现居住城市
  workYear: string;
  startWorkYear: string; // 开始工作年份
  degree: string;
  degreeName: string; // 最高学历
  expectedCityId: string;
  expectedCity: string; // 期望城市
}

export const resumeBaseInfoDefault = {
  unionId: '',
  name: '', // 姓名
  age: '',
  gender: '', // 性别
  genderName: '',
  birthday: '', // 出生年月
  photoIdL: '',
  photoUrl: '', // 头像
  interCode: '', // 区号
  interCodeName: '',
  phone: '', // 电话
  email: '', // 邮箱
  cityId: '',
  cityName: '', // 现居住城市
  workYear: '',
  startWorkYear: '', // 开始工作年份
  degree: '',
  degreeName: '', // 最高学历
  expectedCityId: '',
  expectedCity: '', // 期望城市
};

export interface ISocialEduExperience {
  renderId: number;
  unionId: string;
  schoolCode: string;
  school: string;
  major: string;
  majorCode: string;
  degree: string;
  degreeName: string;
  startDate: number | null;
  endDate: number | null;
}

export const resumeEduExpListDefault = {
  renderId: 0,
  unionId: '',
  schoolCode: '',
  school: '',
  major: '',
  majorCode: '',
  degree: '',
  degreeName: '',
  startDate: null,
  endDate: null,
};

export interface ISocialWorkExperience {
  renderId: number;
  unionId: string;
  companyId: string;
  companyName: string; // 公司名称
  department?: string; // 部门名称
  position: string; // 职位名称
  workType: string;
  workTypeName: string; // 工作类型
  startDate: number | null; // 在职开始时间
  endDate: number | null; // 在职结束时间
  workDescription?: string; // 工作描述
}
export const resumeWorkExpListDefault = {
  renderId: 0,
  unionId: '',
  companyId: '',
  companyName: '',
  department: '',
  position: '',
  workType: '',
  workTypeName: '',
  startDate: null,
  endDate: null,
  workDescription: '',
};

export interface ISocialProjectExperience {
  renderId: number;
  unionId: string;
  projectName: string; // 项目名称
  projectPosition: string; // 项目角色
  startDate: number | null; // 开始时间
  endDate: number | null; // 结束时间
  projectUrl?: string; // 项目链接
  projectDescription?: string; // 项目描述
  companyName: string; // 公司名称
}
export const resumeProjectExpListDefault = {
  unionId: '',
  projectName: '',
  projectPosition: '',
  startDate: null,
  endDate: null,
  projectUrl: '',
  projectDescription: '',
  companyName: '',
};

export interface ISocialHonor {
  renderId: number;
  unionId: string;
  honorName: string; // 荣誉名称
  honorDesc: string; // 荣誉描述
}

export const resumeHonorListDefault = {
  renderId: 0,
  unionId: '',
  honorName: '',
  honorDesc: '',
};

export interface ISocialLanguage {
  renderId: number;
  unionId: string;
  language: string;
  languageName: string; // 语言类型
  level: string; // 语言水平
  levelName: string;
  examinationName?: string;
  examinationId?: string;
  score?: string;
}

export const resumeLanguageListDefault = {
  renderId: 0,
  unionId: '',
  language: '',
  languageName: '',
  level: '',
  levelName: '',
};

export interface ISocialCertificate {
  renderId: number;
  unionId: string;
  name: string; // 证书名称
}

export const resumeCertificateListDefault = {
  renderId: 0,
  unionId: '',
  name: '',
};

export interface ISocialPatent {
  renderId: number;
  unionId: string;
  patentName: string; // 专利名称
  ownerName: string; // 专利人
  obtainDate: string; // 取得日期
  patentUrl: string; // 专利链接
  description: string; // 专利描述
}

export const resumePatentListDefault = {
  renderId: 0,
  unionId: '',
  patentName: '',
  ownerName: '',
  obtainDate: '',
  patentUrl: '',
  description: '',
};

export interface ISocialExam {
  renderId: number;
  unionId: string;
  examName: string; // 考试名称
  score: string; // 分数
  examDate: string; // 考试日期
}

export const resumeExamListDefault = {
  renderId: 0,
  unionId: '',
  examName: '',
  score: '',
  examDate: '',
};

export interface ISocialAccount {
  renderId: number;
  unionId: string;
  name: string; // 账号名称
  homePage: string; // URL
}

export const resumeSocialAccountListDefault = {
  renderId: 0,
  unionId: '',
  name: '',
  homePage: '',
};

export interface ISocialWorksAttachmentList {
  renderId: number;
  unionId: string;
  fileId: string;
  name: string;
  type: string;
  fileTypeCode: string;
}

export interface ISocialResumeAttachmentList {
  unionId: string;
  renderId: number;
  fileId: string;
  name: string;
  type: string;
  fileTypeCode: string;
}

export const resumeAttachmentListDefault = {
  renderId: 0,
  unionId: '',
  fileId: '',
  name: '',
  type: '',
  fileTypeCode: '',
};

export const socialTabItems = [
  {
    key: 'base_info_edit',
    title: '基础信息',
  },
  {
    key: 'edu_experience_edit',
    title: '教育经历',
  },
  {
    key: 'work_experience_edit',
    title: '工作/实习经历',
  },
  {
    key: 'project_experience_edit',
    title: '项目经历',
  },
  {
    key: 'honor_edit',
    title: '荣誉',
  },
  {
    key: 'language_standard_edit',
    title: '语言水平',
  },
  {
    key: 'certificate_edit',
    title: '证书',
  },
  {
    key: 'patent_edit',
    title: '专利',
  },
  {
    key: 'exam_edit',
    title: '考试',
  },
  {
    key: 'social_account_edit',
    title: '社交账号',
  },

  {
    key: 'upload_sample_reel_edit',
    title: '作品集',
  },
  {
    key: 'self_description_edit',
    title: '自我描述',
  },
];
